import React from "react";
import { VerticalSeparator } from "../../../../settingsForms/separators/verticalSeparator/verticalSeparator";
import { ActiveCheckbox } from "../../../taggingSettings/components/activeCheckbox/ActiveCheckbox";
import { ExistingTagGroupFormType } from "../../types";
import { ActiveHoursColumn } from "../activeHoursColumn/activeHoursColumn";
import tagGroupsStyles from "../tagGroups.css";
import { GroupNameColumn } from "../groupName/groupNameColumn";
import { GroupTags } from "../groupTags/groupTags";
import styles from "./existingGroupBox.css";
import { ShowDetailsCheckbox } from "../../../taggingSettings/components/showDetailsCheckbox/ShowDetailsCheckbox";

interface Props {
  form: ExistingTagGroupFormType;
  isExpanded: boolean;
}
export const ExistingGroupBox = ({ form, isExpanded }: Props) => {
  return (
    <div className={styles.form}>
      <div className={tagGroupsStyles.form}>
        <GroupNameColumn form={form} />
        <VerticalSeparator />
        <GroupTags tags={form.$.tagIds} />
        <VerticalSeparator />
        <div className={styles["checkbox-container"]}>
          <ActiveCheckbox field={form.$.active} id={form.$.id.$} />
          <ShowDetailsCheckbox
            field={form.$.showInConversationDetails}
            id={form.$.id.$}
            noMarginBottom
          />
        </div>
      </div>
      {isExpanded && (
        <div className={styles.expanded}>
          <ActiveHoursColumn activeHours={form.$.activeHours} />
        </div>
      )}
    </div>
  );
};
